import { render, staticRenderFns } from "./FullFatTop.vue?vue&type=template&id=37e30018&"
import script from "./FullFatTop.vue?vue&type=script&lang=js&"
export * from "./FullFatTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports